/*
 * Sidebar.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 04 2023 mys Company
 */

import icnprofile from '../../assets/icons/icn_profile.png'
import SideBarMenuItem from '../../component/general/SideBarMenuItem'
import { getMenus } from '../../config/constant/constants'
import { localization } from '../../config/localize/localizable'
const Sidebar = () => {
    //
    // MARK: VARIABLE
    let menus = getMenus()

    return (
        <>
            <div className="h-full bg-white pt-10 shadow-sm  rounded-tl-3xl rounded-bl-3xl overflow-y-auto">
                <div className="pr-6">
                    <div className=" inline-block bg-special1 h-12 w-12 rounded shadow-sm p-1">
                        <img src={icnprofile} className=" right-8 shadow-sm" alt="" />
                    </div>
                    <div className="inline-block p-2">
                        <div className="text-sm">مهدی یوسف پور</div>
                        <div className="text-sm">m.usefpour@gmail.com</div>
                    </div>
                </div>

                <div className="text-sm">
                    {menus &&
                        menus
                            .filter((x) => x.parentId === 0 || (x.parentId === null && x.type === 'SIDE'))
                            .sort(function (a, b) {
                                return a.priority - b.priority
                            })
                            .map((item, index) => {
                                return (
                                    <div key={index}>
                                        <SideBarMenuItem currentMenu={item} items={menus.filter((x) => x.parentId === item.id && x.visible)} />
                                    </div>
                                )
                            })}
                </div>
            </div>
        </>
    )
}

export default Sidebar
